import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property/mitaclub',
    routes: [
      {
        name: 'mitaclub',
        path: '/',
        component: () => import('./mitaclub'),
      },
      {
        name: 'mitaclub',
        path: '/:year',
        component: () => import('./mitaclub'),
      },
      {
        name: 'agentDetail',
        path: '/member/:year/:emailAlias',
        props: true,
        component: () => import('./detail'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });
  return router;
};
